/**
 * Chart configuration constants for EVG parameter visualization
 */

/**
 * Color palette for different EVGs
 */
export const EVG_COLORS = [
  '#3B82F6', // Blue
  '#10B981', // Green
  '#F59E0B', // Amber
  '#EF4444', // Red
  '#8B5CF6', // Purple
  '#EC4899'  // Pink
] as const;

/**
 * Parameter configuration for chart axes and formatting
 */
const temperatureConfig = {
  suffix: '°C',
  yAxisID: 'y-temp',
  label: 'Temperature'
} as const;

export const PARAMETER_CONFIG = {
  voltage: { 
    suffix: 'V', 
    yAxisID: 'y-voltage',
    label: 'Voltage',
    gridColor: '#3B82F620'
  },
  current: { 
    suffix: 'A', 
    yAxisID: 'y-current',
    label: 'Current'
  },
  pwm: {
    suffix: '%',
    yAxisID: 'y-pwm',
    label: 'PWM',
    gridColor: '#F59E0B20'
  },
  temp: temperatureConfig,
  temperature: temperatureConfig
} as const;

/**
 * Chart animation configuration
 */
export const CHART_ANIMATION = {
  duration: 750,
  easing: 'easeInOutQuart' as const
};

/**
 * Chart style configuration
 */
export const CHART_STYLE = {
  borderWidth: 2,
  pointRadius: 3,
  pointHoverRadius: 5,
  tension: 0.4
} as const;

/**
 * Reference bands for normal operating ranges and danger zones.
 * Rendered as subtle background fills on the chart axes.
 */
export const REFERENCE_BANDS = [
  // Voltage — normal operating zone (green)
  { axisId: 'y-voltage', lo: 190, hi: 260, color: 'rgba(16, 185, 129, 0.05)' },
  // Voltage — too low (red)
  { axisId: 'y-voltage', lo: 0,   hi: 180, color: 'rgba(239, 68, 68, 0.04)' },
  // Voltage — too high (red)
  { axisId: 'y-voltage', lo: 260, hi: 500, color: 'rgba(239, 68, 68, 0.04)' },
  // Temperature — danger above 80°C (red)
  { axisId: 'y-temp',    lo: 80,  hi: 300, color: 'rgba(239, 68, 68, 0.04)' },
  // Current — overflow above 50A (red)
  { axisId: 'y-current', lo: 50,  hi: 200, color: 'rgba(239, 68, 68, 0.04)' },
] as const;
